import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * ClaimCard - Reusable claim statistics card component
 * Used in transaction dashboard and company overview pages
 * 
 * @param {string} label - The label text (e.g., "Total Claims")
 * @param {string|number} value - The value to display
 * @param {boolean} isLoading - Whether the card is in loading state
 * @param {boolean} error - Whether there was an error loading data
 * @param {string} className - Additional classes for the card container
 */
export function ClaimCard({ label, value, isLoading = false, error = false, className }) {
    return (
        <div
            className={cn(
                "p-4 rounded-lg bg-card border border-border shadow-sm",
                className
            )}
        >
            <p className="text-sm text-foreground mb-2">{label}</p>
            {isLoading ? (
                <div className="flex items-center py-2">
                    <Loader2 className="h-8 w-8 animate-spin text-primary" />
                </div>
            ) : error ? (
                <p className="text-sm text-destructive">Error</p>
            ) : (
                <p className={cn(
                    "font-bold text-muted-foreground",
                    // Dynamic sizing based on value length
                    //value && value.toString().length > 12 ? "text-xl md:text-2xl" :
                    //value && value.toString().length > 8 ? "text-2xl md:text-3xl" :
                    "text-xl lg:text-2xl xl:text-3xl"
                )}>
                    {value || '-'}
                </p>
            )}
        </div>
    );
}

